import request from '@/utils/request'
const apiPath = '/sys/CityCompanyAddrArea'
const CityCompanyAddrAreaApi = {
  SearchCityCompany(data) {
    return request.post(`${apiPath}/SearchCityCompany`, data)
  },
  saveAddrAreaBatch(data) {
    return request.post(`${apiPath}/saveAddrAreaBatch`, data)
  },
  transfer(data) {
    return request.post(`${apiPath}/transfer`, data)
  },
  CityCompanyTreeList(query) {
    return request.get(`${apiPath}/treeList`, { params: query })
  },
  CityCompanyAddrAreaListForTree(query) {
    return request.get(`${apiPath}/CityCompanyAddrAreaListForTree`, { params: query })
  },
  changeCityArea(data) {
    return request.post('/sys/cityCompanyArea/changeCityArea', data)
  },
}
export default CityCompanyAddrAreaApi
